const tasks = {
  taskGridTitle: "Tasks",
  taskGridDescription: "Creditors list related to the case",
  columnDetails: {
    claimId: "Claim ID",
    taskName: "Task Name",
    type: "Type",
    dueDate: "Due Date",
    status: "Status",
    creditorName: "Creditor Name",
    createdBy: "Created By",
    createdDate: "Created On",
    updatedOn: "Updated On",
    updatedBy: "Updated By",
  },
  search: {
    basicSearch: "Basic Search",
    claimId: "Claim ID",
    name: "Name",
    taskType: "Task Type",
    status: "Status",
    overdue: "Overdue",
    dueDateStart: "Due Date Start",
    dueDateEnd: "Due Date End",
    createdOnStart: "Created On Start",
    createdOnEnd: "Created On End",
  },
};
export default tasks;
